// @ts-ignore
import React, { MouseEvent, useEffect, useState } from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { useProductTemplateContext } from "@/components/product-template-context-provider";
import { useSiteSelectorContext } from "@/components/site-selector-modal/index.ts";
import {
    Button,
    ButtonProps
} from "@/libraries/design/components/button/src/button.tsx";
import {
    useLocale,
    getLocalizedHref
} from "@/libraries/web-framework/index.ts";

export interface UniformTemplateModalButtonProps {
    text: string;
    productKey: string;
    templateName: string;
    pluginModuleKey?: string;
    href?: string;
}

const UniformTemplateModalButton = (props: UniformTemplateModalButtonProps) => {
    const { text, productKey, templateName, pluginModuleKey, href } = props;

    const { openModalForTemplate } = useSiteSelectorContext();
    const { setTemplate } = useProductTemplateContext();
    const locale = useLocale();

    const [buttonProps, setButtonProps] = useState<ButtonProps>({
        href: getDefaultHref({
            productKey,
            locale
        })
    });
    const fullStargateProductKey =
        productKey === "jira-service-management"
            ? "jira-servicedesk.ondemand"
            : `${productKey}.ondemand`;

    useEffect(() => {
        if (pluginModuleKey && productKey) {
            setTemplate({
                templateId: pluginModuleKey,
                templateName,
                productKey: fullStargateProductKey as ProductKeys
            });

            setButtonProps({
                onClick: (event: MouseEvent<HTMLButtonElement>) => {
                    event.stopPropagation();
                    event.preventDefault();
                    openModalForTemplate({
                        templateId: pluginModuleKey,
                        templateName,
                        productKey: fullStargateProductKey as ProductKeys
                    });
                }
            });
        } else if (href) {
            setButtonProps({
                href: getLocalizedHref({ href, locale })
            });
        }

        return () => {
            setTemplate(null);
        };
    }, []);

    return <Button {...buttonProps}>{text}</Button>;
};

interface GetDefaultHrefArgs {
    productKey: string;
    locale: string;
}
function getDefaultHref(args: GetDefaultHrefArgs) {
    const { locale, productKey } = args;

    if (productKey === "jira-software") {
        return getLocalizedHref({
            href: "/try/cloud/signup?bundle=jira&edition=free",
            locale
        });
    }
    if (productKey === "confluence") {
        return getLocalizedHref({
            href: "/try/cloud/signup?bundle=confluence&edition=free",
            locale
        });
    }
    if (productKey === "jira-service-management") {
        return getLocalizedHref({
            href: "/try/cloud/signup?bundle=jira-service-management&edition=free",
            locale
        });
    }

    return "";
}

export default UniformTemplateModalButton;
